module.exports = __webpack_public_path__ + "assets/img/ebfe-bl.svg";